'use client';

import { QueryClientProvider } from '@tanstack/react-query';

import { queryClient } from '@/lib/query-client';

import { AuthProvider } from './AuthProvider';

export function AppDataProviders({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>{children}</AuthProvider>
    </QueryClientProvider>
  );
}
